import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { StyledSelect } from 'lib/styles';

const Container = styled.div`
	margin: 0 0 40px 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

class ColumnCount extends React.Component {
	state = {
	  columnCount: this.props.columnCount,
	}

	shouldComponentUpdate(nextProps) {
	  return this.props.columnCount !== nextProps.columnCount;
	}

	changeHandler = columnCount => {
	  this.setState({ columnCount });
	  this.props.updateSettingsHandler({
	    columnCount
	  })
	}

	render() {
	  const { t } = this.props;
	  return (
	    <Container>
	      <Label>{t('controls/text/settings/column count')}</Label>
	      <StyledSelect
	        id="columnCount"
	        value={this.state.columnCount}
	        style={{ width: '100%' }}
	        options={[
	          {
	            value: '1',
	            name: '1',
	          },
	          {
	            value: '2',
	            name: '2',
	          },
	          {
	            value: '3',
	            name: '3',
	          },
	          {
	            value: '4',
	            name: '4',
	          }
	        ]}
	        onChange={e => this.changeHandler(e.target.value)}
	      />
	    </Container>
	  )
	}
}

ColumnCount.propTypes = {
	t: PropTypes.func,
	updateSettingsHandler: PropTypes.func,
	columnCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default translate('translations')(ColumnCount)
